import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const CMD_ROLE_HEADERS = { "Cache-Control": "no-cache", "x-actor-role": "cmd" };

// GET /api/v1/chat/conversations
export const getConversations = createAsyncThunk("chat/getConversations", async () => {
  try {
    const response = await api.get("/api/v1/chat/conversations", {
      headers: CMD_ROLE_HEADERS,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error fetching conversations");
  }
});

// GET /api/v1/chat/messages/:conversationId?limit=30
export const getMessages = createAsyncThunk("chat/getMessages", async ({ conversationId, limit = 30 }) => {
  try {
    const response = await api.get(`/api/v1/chat/messages/${conversationId}`, {
      params: { limit },
      headers: CMD_ROLE_HEADERS,
    });
    return { conversationId, ...response.data };
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error fetching messages");
  }
});

// POST /api/v1/chat/conversations/direct — gets or creates a direct conversation with a nurse/patient
export const startDirectConversation = createAsyncThunk("chat/startDirectConversation", async ({ targetId, targetType }) => {
  try {
    const response = await api.post(
      "/api/v1/chat/conversations/direct",
      { targetId, targetType },
      { headers: CMD_ROLE_HEADERS },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error starting conversation");
  }
});
